<template>
  <div class="fts-history-notification-target">
    <fts-profile
      :user-list="users"
      :user-name="target"
      :profile-photo-size="14"
      fallback-name="(disabled user)"
      v-if="isEmail"
    />

    <fts-profile
      :user-list="users"
      :profile-id="target"
      :profile-photo-size="14"
      fallback-name="(disabled user)"
      v-else
    />
  </div>
</template>

<script>
import { emailValidator } from '../../commons/validator';
import FTSProfile from '../FTSProfile';

export default {
  components: {
    "fts-profile": FTSProfile
  },
  props: {
    target: String,
    users: Array,
  },
  computed: {
    isEmail() {
      return emailValidator(this.target);
    }
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-history-notification-target {
  min-width: 0;
}
</style>